import { useEffect, useState } from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { WithConfirmation } from '../common';
import { teamService } from '../../services';
import Avatar from '../Avatar';
import Loading from '../Loader';
import { TEAM, API_FAILURE_ERROR } from '../../constants';
import { ReactivateMemberModal, InactiveTeamKababMenu, MemberName } from '.';
import DeleteButton from '../DeleteButton';
import { convertSecondsToHoursAndMinutes } from '../../helpers';

const pageNumber = 1;
const pageLimit = 500;

const InactiveTeamMember = ({ updateBreadCrumbTitle }) => {
  const [state, setState] = useState([]);
  const [currentPage, setCurrentPage] = useState(pageNumber);
  const [isLoading, setLoading] = useState(true);
  const [metaData, setMetaData] = useState({});
  const [loadMemberData, setloadMemberData] = useState(true);
  const RemoveWithConfirmation = WithConfirmation(DeleteButton);

  const userDetails = useSelector((userstate) => userstate.userReducer);
  const userRole = userDetails.role;
  // delete member
  const handleMemberDelete = (userId) => {
    setLoading(true);
    const params = {
      userId,
      teamOwnerId: localStorage.getItem('teamOwnerId'),
    };
    teamService
      .delete_team_member(params)
      .then(() => {
        setLoading(false);
        toast.success(TEAM.MEMBER_DELETE_SUCCESS);
        const members = state.filter((member) => member.userId !== userId);
        setState(members);
      })
      .catch((errResponse) => {
        setLoading(false);
        if ('message' in errResponse) {
          toast.error(errResponse.message);
        } else {
          toast.error(API_FAILURE_ERROR);
        }
      });
  };

  // Reactivate member
  const handleStatusUpdate = (userId, userStatus, reason) => {
    setLoading(true);
    const params = {
      userId,
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      status: userStatus,
      reason,
    };
    teamService
      .update_user_status(params)
      .then((response) => {
        setLoading(false);
        if (response.message === 'Success') {
          toast.success(TEAM.STATUS_UPDATE_ACTIVATE_SUCCESS);
          const members = state.filter((member) => member.userId !== userId);
          setState(members);
        }
      })
      .catch((errResponse) => {
        setLoading(false);
        if ('message' in errResponse) {
          toast.error(errResponse.message);
        } else {
          toast.error(API_FAILURE_ERROR);
        }
      });
  };
  useEffect(() => {
    teamService
      .get_team_members_data({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
        page: currentPage,
        filter: '{ "memberStatus": "inactive" }',
        limit: pageLimit,
        summaryList: false,
      })
      .then((response) => {
        setLoading(false);
        if (response.data) {
          const { members, metadata } = response.data;
          setState([...state, ...members]);
          updateBreadCrumbTitle(`(${metadata.total})`);
          if (Math.ceil(metadata.total / pageLimit) <= currentPage) {
            setloadMemberData(false);
          }
          setMetaData(metadata);
        }
      })
      .catch(() => {
        toast.error(API_FAILURE_ERROR);
        setLoading(false);
      });
  }, [currentPage]);

  const updateCurrenPageNumber = () => {
    // Trigger only if more contents are available
    if (loadMemberData) {
      setCurrentPage(currentPage + 1);
    }
  };

  window.onscroll = function () {
    const scrollable =
      document.documentElement.scrollHeight - window.innerHeight;
    const scrolled = window.scrollY;

    // If the user is reached bottom of the page
    if (Math.ceil(scrolled) === scrollable) {
      updateCurrenPageNumber();
    }
  };
  return isLoading ? (
    <Loading contentAreaOnly />
  ) : (
    <section className="card-list-view">
      {state.length > 0 ? (
        state.map((el, i) => {
          // Get the totalTasks count
          const totalTasks = el.tasks.reduce(
            (total, task) => total + task.tasks,
            0
          );
          return (
            <div className="card" key={i} data-id={`${el.userId}`}>
              <div className="card-body">
                <span className="avatar-lg">
                  <Avatar
                    firstName={el.firstName}
                    lastName={el.lastName}
                    imgPath={el.avatar ? el.avatar : ''}
                  />
                </span>
                <div className="member-info">
                  <MemberName
                    memberName={`${el.firstName} ${el.lastName}`}
                    hourlyRate={el.rates.costRate}
                    defaultCurrency={metaData.defaultCurrency}
                  />
                  <p className="small text-center text-muted mb-3">
                    {el.email}
                  </p>
                  <p className="small text-center text-muted mb-3">
                    last worked{' '}
                    {el.workSession.lastWorkSession !== null ? (
                      <time className="small text-muted">
                        {moment(el.workSession.lastWorkSession).fromNow()}
                      </time>
                    ) : (
                      <span className="badge bg-secondary-soft">
                        Not available
                      </span>
                    )}
                  </p>
                  <p className="small text-center text-muted mb-3">
                    Reason : {el.deactivationReason}
                  </p>
                </div>
                <div className="list-group list-group-flush mb-4 worksession-info">
                  <div className="list-group-item">
                    <div className="col py-4 text-center align-to-left">
                      <h6 className="text-uppercase text-muted">
                        DEACTIVATION DATE
                      </h6>
                      <h2 className="mb-0">
                        {moment.utc(el.deactivationDate).format('MMM DD, YYYY')}
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="row no-gutters border-left align-to-left">
                  <div className="col py-4 text-center align-to-left">
                    <h6 className="text-uppercase text-muted">TOTAL HOURS</h6>

                    {el.workSession.totalWorksessionSeconds > 0 ? (
                      <h2 className="mb-0">
                        {convertSecondsToHoursAndMinutes(
                          el.workSession.totalWorksessionSeconds
                        )}
                      </h2>
                    ) : (
                      <h2 className="mb-0">0h 0m</h2>
                    )}
                  </div>
                  <div className="col py-4 text-center border-left align-to-left">
                    <h6 className="text-uppercase text-muted">TOTAL TASKS</h6>
                    {totalTasks >= 1 ? (
                      <h2 className="mb-0">{totalTasks}</h2>
                    ) : (
                      <span className="badge bg-secondary-soft">
                        No open tasks
                      </span>
                    )}
                  </div>
                </div>

                {/* Footer */}
                <div className="d-flex justify-content-between">
                  {userRole !== 'manager' && (
                    <div>
                      <ReactivateMemberModal
                        userId={el.userId}
                        handleStatusUpdate={handleStatusUpdate}
                      />
                      <RemoveWithConfirmation
                        modalProps={{
                          title: `Delete Team Member`,
                          action: handleMemberDelete,
                          params: el.userId,
                          content: [
                            'Deleting this team member will cause all data, including time logs and screenshots, to be permanently deleted without restoration',
                          ],
                          actionBtnText: 'Delete',
                        }}
                      />
                    </div>
                  )}
                </div>
                {/* Dropdown */}
                <InactiveTeamKababMenu userId={el.userId} />
              </div>
            </div>
          );
        })
      ) : (
        <div className="card">
          <div className="card-body d-flex justify-content-center">
            <div className="alert alert-info">No inactive Team Members</div>
          </div>
        </div>
      )}
    </section>
  );
};
InactiveTeamMember.propTypes = {
  updateBreadCrumbTitle: PropTypes.func,
};
export default InactiveTeamMember;
